import script from "./PwaUserInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./PwaUserInfo.vue?vue&type=script&setup=true&lang=ts"

import "./PwaUserInfo.vue?vue&type=style&index=0&id=f8925c9a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f8925c9a"]])

export default __exports__